module.exports = __webpack_public_path__ + "static/sidefx-logo-3bf3990f27c27463d6442fb2a5151b85.png";